import plans from '../data/plans';

export default function getPlanData(state, planId) {
    if (!state) return {}
	if (state === 'free') {
		return {
			id: 1,
			description: 'Tracking 10 parcels.',
			title: 'Free',
			price: '0',
			period: 'month',
			numberOfTracks: 10,
			options: [],
		};
	}
	return plans.find((plan) => plan.id == planId);
}
